import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {MUTATION_KEYS, queryClient, QUERY_KEYS} from '@/queryClient'
import {
    httpConfirmSiarExportTransmission,
    HttpConfirmTransmissionPayload
} from '@/features/projects/siar-bulk-export/http/siarBulkExport.http'

export const useConfirmSiarExportTransmission = (
    options?: Omit<UseMutationOptions<void, AxiosError, HttpConfirmTransmissionPayload>, 'mutationKey' | 'mutationFn'>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CONFIRM_SIAR_EXPORT_TRANSMISSION],
        mutationFn: payload => httpConfirmSiarExportTransmission(payload),
        onSettled: (...args) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.SIAR_BULK_EXPORT_HISTORY]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS]})
            options?.onSettled?.(...args)
        }
    })
}
